import { render, staticRenderFns } from "./test-items-edit.vue?vue&type=template&id=3ec166e2&scoped=true&"
import script from "./test-items-edit.vue?vue&type=script&lang=ts&"
export * from "./test-items-edit.vue?vue&type=script&lang=ts&"
import style0 from "./test-items-edit.vue?vue&type=style&index=0&id=3ec166e2&prod&lang=scss&scoped=true&"
import style1 from "./test-items-edit.vue?vue&type=style&index=1&id=3ec166e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec166e2",
  null
  
)

export default component.exports